import { Box } from "@mui/material"
import SometimeHint from "./SometimesHint"


interface SometimesHintsTrackerProps {
    nbSometimes: number
}

const SometimesHintsTracker = (props: SometimesHintsTrackerProps) => {


    return <Box display="flex" textAlign={"center"} alignItems="flex-center" margin="10px" flexDirection={"column"}>
        {Array.from(Array(props.nbSometimes), (e, i) => {
            return <SometimeHint />

        })}

    </Box>
}

export default SometimesHintsTracker